var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGpsFilledSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45.72 63.52",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ec6747;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1",
    transform: "matrix(1, 0, 0, 0.9999999999999999, 3.552713678800501e-15, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M 22.86 0 C 10.23 0 0 10.23 0 22.86 C 0 35.49 22.86 63.52 22.86 63.52 C 22.86 63.52 45.71 35.49 45.72 22.87 C 45.71 10.23 35.48 0 22.86 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpsFilledSelected);
export default __webpack_public_path__ + "static/media/GPS_filled_selected.1225d1b2d2323d9b032fbdd492a67d76.svg";
export { ForwardRef as ReactComponent };